const $ = require('jquery');

// The goal here is to pre-select options of the dropdowns based on the page URL that the form is being loaded on.


//-----------------------------------------------------------
// Residential Services Form
//-----------------------------------------------------------
// Quick check to see if the form is loaded before proceeding
if ($('.webform-submission-request-estimate-res-form').length) {

  // Retrieve current URL
  var $url = document.URL;

  // If on the Ants Page
  if ($url.indexOf('ant-control') != -1) {
    $("#edit-help-with option[value='30']").attr("selected","selected");
  }

  // If on the Bed Bugs Page
  if ($url.indexOf('bed-bug-control') != -1) {
    $("#edit-help-with option[value='32']").attr("selected","selected");
  }

  // If on the Fall Invaders Page
  if ($url.indexOf('fall-pest-invaders') != -1) {
    $("#edit-help-with option[value='67']").attr("selected","selected");
  }

  // If on the Rodents Page
  if ($url.indexOf('rodent-control') != -1) {
    $("#edit-help-with option[value='36']").attr("selected","selected");
  }

  // If on the Mosquitoes Page
  if ($url.indexOf('mosquito-control') != -1) {
    $("#edit-help-with option[value='40']").attr("selected","selected");
  }

  // If on the Termites Page
  if ($url.indexOf('termite-control') != -1) {
    $("#edit-help-with option[value='37']").attr("selected","selected");
  }

  // If on the Ticks Page
  if ($url.indexOf('tick-control') != -1) {
    $("#edit-help-with option[value='39']").attr("selected","selected");
  }

  // If on the Wasps Hornets Page
  if ($url.indexOf('stinging-insect-pest-control') != -1) {
    $("#edit-help-with option[value='38']").attr("selected","selected");
  }

  // If on the Home Quarterly Program Page
  if ($url.indexOf('home-quarterly-pest-control-program') != -1) {
    $("#edit-help-with option[value='33']").attr("selected","selected");
  }

  if ($url.indexOf('mass-home-quarterly-pest-control') != -1) {
    $("#edit-help-with option[value='33']").attr("selected","selected");
  }

  // If on any of the Wildlife Pages
  //if (($url.indexOf('bat-control') != -1) || ($url.indexOf('racoon-control') != -1) || ($url.indexOf('skunk-control') != -1) || ($url.indexOf('squirrel-control') != -1) || ($url.indexOf('bird-beaver-woodchuck-control') != -1)) {
  //  $("#edit-help-with option[value='41']").attr("selected","selected");
  //}

}



//-----------------------------------------------------------
// Wildlife Services Form
//-----------------------------------------------------------
// Quick check to see if the form is loaded before proceeding
if ($('.webform-submission-request-a-free-estimate-wildlife-form').length) {

  // Retrieve current URL
  var $url = document.URL;

  // If on the Bats Page
  if ($url.indexOf('bat-control') != -1) {
    $("#edit-help-with option[value='58']").attr("selected","selected");
  }

  // If on the Raccoons Page
  if ($url.indexOf('raccoon-control') != -1) {
    $("#edit-help-with option[value='60']").attr("selected","selected");
  }

  // If on the Skunks Page
  if ($url.indexOf('skunk-control') != -1) {
    $("#edit-help-with option[value='61']").attr("selected","selected");
  }

  // If on the Squirrels Page
  if ($url.indexOf('squirrel-control') != -1) {
    $("#edit-help-with option[value='62']").attr("selected","selected");
  }

  // If on the Other Wildlife Page
  if ($url.indexOf('bird-beaver-woodchuck-control') != -1) {
    $("#edit-help-with option[value='59']").attr("selected","selected");
  }
}



//-----------------------------------------------------------
// Commercial Services Form
//-----------------------------------------------------------
// Quick check to see if the form is loaded before proceeding
if ($('.webform-submission-request-a-free-estimate-commerci-form').length) {

  // Retrieve current URL
  var $url = document.URL;

  // If on the Food and Pharmaceutical Page
  if ($url.indexOf('food-and-pharmaceutical-pest-control') != -1) {
    $("#edit-business-type option[value='44']").attr("selected","selected");
  }

  // If on the Healthcare Facility Page
  if ($url.indexOf('healthcare-pest-protection') != -1) {
    $("#edit-business-type option[value='45']").attr("selected","selected");
  }

  // If on the Hotel Page
  if ($url.indexOf('hotel-pest-control') != -1) {
    $("#edit-business-type option[value='46']").attr("selected","selected");
  }

  // If on the Multi-Family Housing Page
  if ($url.indexOf('multi-family-pest-control') != -1) {
    $("#edit-business-type option[value='47']").attr("selected","selected");
  }

  // If on the Retail Food Page
  if ($url.indexOf('retail-food-pest-protection') != -1) {
    $("#edit-business-type option[value='49']").attr("selected","selected");
  }

  // If on the Schools and Universities Page
  if ($url.indexOf('schools-universities-pest-control') != -1) {
    $("#edit-business-type option[value='50']").attr("selected","selected");
  }
}



//-----------------------------------------------------------
// The special Massachusetts OTT Campaign Form
//-----------------------------------------------------------
// Quick check to see if the form is loaded before proceeding
if ($('.webform-submission-request-a-free-estimate-ma-ott-form').length) {

  // Retrieve current URL
  var $url = document.URL;

  // If on the Other Wildlife Page
  if ($url.indexOf('mass-home-quarterly-pest-control') != -1) {
    $("#edit-help-with option[value='33']").text('MA Home Quarterly Program').attr("selected","selected");
  }
}



//-----------------------------------------------------------
// Free Quote/Consultation Sticky Bars
//-----------------------------------------------------------
// Quick check to see if the form is loaded before proceeding
if ($('#services-sticky-bar').length) {

  // Get the form paragraph container
  //const servicesForm = $('.form-with-borders');

  // Find the bottom position of the form (by adding the scroll position of the top of form + height of form)
  //const servicesFormBottom = servicesForm.offset().top + servicesForm.outerHeight(true);

  // General offset now that the sticky bar gets shown sooner
  var scrollOffset = 300;

  // Function to add/remove the "sticky" class based on scroll position
  function servicesStickyBar() {
    if (window.pageYOffset >= scrollOffset) {
      $('#services-sticky-bar').addClass('sticky');
    } else {
      $('#services-sticky-bar').removeClass('sticky');
    }
  }

  // Init the function and re-execute on scroll
  servicesStickyBar();
  $(window).scroll(function() {
    servicesStickyBar();
  });

}
